import { Row } from 'app/design/primitives/box';
import { isAnyWhiteLabel } from 'app/utils/helpers';
import type { useDesktopLandingData } from '../use-desktop-landing-data';
import { SocialMediaCard, WriteToMayorCard } from './immature-neighbourhood';

export function NeighbourhoodSocialActions({
  neighbourhoodStatus,
}: Pick<ReturnType<typeof useDesktopLandingData>, 'neighbourhoodStatus'>) {
  const showWriteToMayor = neighbourhoodStatus?.writeToMayor && !isAnyWhiteLabel();
  const showSocialMedia = neighbourhoodStatus?.joinSocialMedia;
  if (!showWriteToMayor && !showSocialMedia) return null;
  return (
    <Row gap="spacing.general.x4" alignItems="stretch">
      {showWriteToMayor ? <WriteToMayorCard /> : null}
      {showSocialMedia ? <SocialMediaCard /> : null}
    </Row>
  );
}
